import { useState } from "react";
import { useLocation } from "wouter";
import { Button } from "@/components/ui/button";
import { Settings, LayoutDashboard, UserPlus } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { InviteClientDialog } from "./InviteClientDialog";
import { UserMenu } from "@/components/UserMenu";
import { useGuardedSignOut } from "@/components/LogoutSaveCheck";

interface AdvisorNavProps {
  advisorName?: string;
  companyName?: string;
  onChangePassword: () => void;
}

export function AdvisorNav({ advisorName, companyName, onChangePassword }: AdvisorNavProps) {
  const { logout } = useAuth();
  // s227 (LOGOUT-SAVE-CHECK-1): every sign-out goes through the one check (a no-op here: no Cat A values).
  const guardedSignOut = useGuardedSignOut();
  const [location, setLocation] = useLocation();
  const [inviteOpen, setInviteOpen] = useState(false);

  const navItems = [
    { label: "Dashboard", icon: LayoutDashboard, path: "/dashboard" },
    { label: "Settings", icon: Settings, path: "/settings" },
  ];

  return (
    <>
      <header className="nav-header sticky top-0 z-50 w-full px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div>
            <span className="font-semibold text-white text-base">Advisor Portal</span>
            {companyName && (
              <span className="text-white/60 text-sm ml-2">— {companyName}</span>
            )}
          </div>
        </div>

        <nav className="flex items-center gap-1">
          {navItems.map(item => (
            <Button
              key={item.path}
              type="button"
              variant="ghost"
              size="sm"
              className={`text-white/80 hover:text-white hover:bg-white/10 ${location === item.path ? "text-white bg-white/10" : ""}`}
              onClick={() => setLocation(item.path)}
            >
              <item.icon className="h-4 w-4 mr-1.5" />
              {item.label}
            </Button>
          ))}
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="text-white/80 hover:text-white hover:bg-white/10 ml-1"
            onClick={() => setInviteOpen(true)}
          >
            <UserPlus className="h-4 w-4 mr-1.5" />
            Invite Client
          </Button>
          <div className="w-px h-5 bg-white/20 mx-2" />
          <UserMenu
            onLogout={() => guardedSignOut(logout)}
            onChangePassword={onChangePassword}
            userName={advisorName}
          />
        </nav>
      </header>

      <InviteClientDialog open={inviteOpen} onOpenChange={setInviteOpen} />
    </>
  );
}
